import { memo, useEffect } from 'react';

interface NapsterSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const NapsterSpinner = memo(
  ({ size = 'medium', className = '' }: NapsterSpinnerProps) => {
    const sizeClasses = {
      small: 'w-8 h-8',
      medium: 'w-12 h-12',
      large: 'w-16 h-16',
    };

    useEffect(() => {
      // Add the keyframes to the document if they don't exist
      if (!document.getElementById('napster-spinner-styles')) {
        const style = document.createElement('style');
        style.id = 'napster-spinner-styles';
        style.textContent = `
                @keyframes napster-dash {
                    0% {
                        stroke-dashoffset: 0;
                    }
                    100% {
                        stroke-dashoffset: 272;
                    }
                }
            `;
        document.head.appendChild(style);
      }
    }, []);

    return (
      <div className={`flex flex-col items-center justify-center ${className}`}>
        <div
          className={`${sizeClasses[size]} flex items-center justify-center`}>
          <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full">
            <defs>
              <linearGradient
                id="napster-spinner-gradient"
                x1="0"
                y1="0"
                x2="100"
                y2="0"
                gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#fcfcfc" />
                <stop offset="100%" stopColor="#fcfcfc" />
              </linearGradient>
            </defs>
            <path
              d="M50,15.9c-9.8,0-16.5,3.7-20.4,6.6-3.1-3-7.8-6.8-12.7-8l-5-1.2h0v34.6c0,10.1,4,19.6,11.2,26.8,7,7.1,16.8,11.2,26.8,11.2s19.6-4,26.8-11.2c7.1-7,11.2-16.8,11.2-26.8V13.3l-4.9,1.1c-5.2,1.2-9.9,5-12.8,8-3.7-2.8-10.5-6.5-20.3-6.5"
              stroke="url(#napster-spinner-gradient)"
              strokeWidth="8"
              strokeDasharray="136"
              strokeLinecap="round"
              fill="none"
              style={{
                strokeDashoffset: '136',
                animation:
                  'napster-dash 1s cubic-bezier(0.35, 0.125, 0.625, 0.85) infinite',
              }}
            />
          </svg>
        </div>
      </div>
    );
  },
);

NapsterSpinner.displayName = 'NapsterSpinner';
